import classNames from 'classnames';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import PlayerHeadshot from '~/components/PlayerHeadshot/PlayerHeadshot';
import StyledComponent from '~/components/Styled/Styled';

import css from '~/components/ActivePlayer/ActivePlayer.scss';

/* eslint-disable */
/* prettier-ignore */
const ActivePlayer = ({ playerType, player, playerStats }) => {
  if (playerType === 'batter') {
    const formattedBattingAverage = get(playerStats, 'formatted_batting_average', '.000');
    const formattedOnBasePercentage = get(playerStats, 'formatted_on_base_percentage', '.000');
    const runsScored = get(playerStats, 'runs_scored', '0');
    const homeRuns = get(playerStats, 'home_runs', '0');
    const runsBattedIn = get(playerStats, 'runs_batted_in', '0');
    const strikeOuts = get(playerStats, 'strike_outs', '0');
    const walks = get(playerStats, 'walks', '0');

    return (
      <div className={css.activePlayer}>
        <div>
          <h3 className={css.title}>Batting</h3>
          <div>
            <div className={css.container}>
              <div className={css.logoNumber}>
                <img className={css.tableLogo} src={player.teams[0].logos.small} alt={player.full_name} />
                <div className={css.playerNumber}>{player.number}</div>
              </div>
              <div className={css.playerLogo}>
                <PlayerHeadshot player={player} size={'small'} />
              </div>
              <div className={css.column}>
                <div className={css.table}>
                  <span className={classNames(css.playerName, css.batter)}>{player.full_name}</span>
                  <div className={css.row}>
                    <div className={css.cell}>{formattedBattingAverage}</div>
                    <div className={css.cell}>{formattedOnBasePercentage}</div>
                    <div className={css.cell}>{runsScored}</div>
                    <div className={css.cell}>{homeRuns}</div>
                    <div className={css.cell}>{runsBattedIn}</div>
                    <div className={css.cell}>{strikeOuts}</div>
                    <div className={css.cell}>{walks}</div>
                  </div>
                  <div className={css.row}>
                    <div className={classNames(css.cell, css.statTitle)}>Avg.</div>
                    <div className={classNames(css.cell, css.statTitle)}>Obp.</div>
                    <div className={classNames(css.cell, css.statTitle)}>R</div>
                    <div className={classNames(css.cell, css.statTitle)}>HR</div>
                    <div className={classNames(css.cell, css.statTitle)}>RBI</div>
                    <div className={classNames(css.cell, css.statTitle)}>K</div>
                    <div className={classNames(css.cell, css.statTitle)}>BB</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (playerType === 'pitcher') {
    const inningsPitched = get(playerStats, 'innings_pitched', '0.0');
    const hits = get(playerStats, 'hits', '0');
    const runs = get(playerStats, 'runs', '0');
    const earnedRuns = get(playerStats, 'earned_runs', '0');
    const strikeOuts = get(playerStats, 'strike_outs', '0');
    const walks = get(playerStats, 'walks', '0');
    const earnedRunAverage = get(playerStats, 'earned_run_average', '0.00');

    return (
      <div className={css.activePlayer}>
        <div>
          <h3 className={css.title}>Pitching</h3>
          <div>
            <div className={css.container}>
              <div className={css.logoNumber}>
                <img className={css.tableLogo} src={player.teams[0].logos.small} alt={player.full_name} />
                <div className={css.playerNumber}>{player.number}</div>
              </div>
              <div className={css.playerLogo}>
                <PlayerHeadshot player={player} size={'small'} />
              </div>
              <div className={css.column}>
                <div className={css.table}>
                  <span className={classNames(css.playerName, css.pitcher)}>{player.full_name}</span>
                  <div className={css.row}>
                    <div className={css.cell}>{inningsPitched}</div>
                    <div className={css.cell}>{hits}</div>
                    <div className={css.cell}>{runs}</div>
                    <div className={css.cell}>{earnedRuns}</div>
                    <div className={css.cell}>{strikeOuts}</div>
                    <div className={css.cell}>{walks}</div>
                    <div className={css.cell}>{earnedRunAverage}</div>
                  </div>
                  <div className={css.row}>
                    <div className={classNames(css.cell, css.statTitle)}>IP</div>
                    <div className={classNames(css.cell, css.statTitle)}>H</div>
                    <div className={classNames(css.cell, css.statTitle)}>R</div>
                    <div className={classNames(css.cell, css.statTitle)}>ER</div>
                    <div className={classNames(css.cell, css.statTitle)}>K</div>
                    <div className={classNames(css.cell, css.statTitle)}>BB</div>
                    <div className={classNames(css.cell, css.statTitle)}>ERA</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <div />;
};

ActivePlayer.displayName = 'ActivePlayer';

ActivePlayer.propTypes = {
  playerType: PropTypes.string.isRequired,
  player: PropTypes.object.isRequired,
  playerStats: PropTypes.object.isRequired,
};

export default StyledComponent(ActivePlayer, [css]);
